import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonEmployeeList } from "./Common/CommonEmployeeList";

const EmployeePage = () => {
    return (
        <PageWrapper title='Colaboradores'>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonEmployeeList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default EmployeePage;